import React from "react";
import '../stylesheets/comman/privacypolicy.scss';

const PrivacyPolicy = () => {
    return (
        <section className="privacy-section">
            <div className="privacy-container">

                <div className="privacy-container__title">
                    <h1>Privacy Policy</h1>
                </div>

                <div className="privacy-content">

                    <p>MIFAB, Inc. (“MIFAB,” “we,” “our,” or “us”) respects your privacy and is committed to protecting the personal information of visitors to our website, https://www.mifab.com (the “Website”). This Privacy Policy explains how we collect, use, disclose, and protect information when you visit or interact with our Website.</p>
                    <p>This Policy applies solely to information collected through this Website and does not apply to information collected offline or through third-party websites.</p>

                    {/* Section 1 */}
                    <h2>Information You Provide to Us</h2>
                    <p>We may collect personal information that you voluntarily provide, including but not limited to:</p>
                    <ul>
                        <li>Name</li>
                        <li>Company name</li>
                        <li>Email address</li>
                        <li>Phone number</li>
                        <li>Mailing address</li>
                        <li>Any other information you choose to submit through contact forms, emails, or other communications</li>
                    </ul>
                    <h3>Purpose of Use:</h3>
                    <p>We use this information to respond to inquiries, provide requested information, communicate regarding our products or services, and conduct ordinary business operations.</p>

                    {/* Section 2 */}
                    <h2>Information Collected Automatically</h2>
                    <p>When you access or use the Website, certain information may be collected automatically, including:</p>
                    <ul>
                        <li>Internet Protocol (IP) address</li>
                        <li>Browser type and version</li>
                        <li>Device type and operating system</li>
                        <li>Pages visited and referring URLs</li>
                        <li>Date and time of access</li>
                        <li>General website interaction data</li>
                    </ul>
                    <h3>Purpose of Use:</h3>
                    <p>This information is used to:</p>
                    <ul>
                        <li>Operate and maintain the Website</li>
                        <li>Monitor performance and usage</li>
                        <li>Detect and prevent fraud, abuse, or security incidents</li>
                        <li>Improve Website functionality and reliability</li>
                    </ul>
                    <p>This information does <strong>not</strong> include the contents of communications you submit through the Website.</p>

                    {/* Section 3 */}
                    <h2>Cookies and Similar Technologies</h2>
                    <p>The Website uses cookies and similar technologies that are necessary for basic website functionality, security, and performance.</p>
                    <p>These technologies may be used to:</p>
                    <ul>
                        <li>Enable essential Website features</li>
                        <li>Support security services (such as bot and abuse prevention)</li>
                        <li>Maintain session integrity</li>
                    </ul>
                    <p>Where required by law, users are provided with notice and the ability to manage consent through a cookie banner or preference tool.</p>
                    <p>You may also control cookies through your browser settings; however, disabling certain cookies may affect Website functionality.</p>

                    <p className="privacy-content__cookie-label">Cookies used on this website:</p>

                    {/* Essential Cookies */}
                    <div className="cookie-block">
                        <h2>Essential</h2>
                        <p>Essential cookies enable basic functions and are necessary for the proper function of the website.</p>
                        <table className="cookie-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>wpconsent_geolocation</td>
                                    <td>This cookie is used to store the consent settings based on the visitor's location.</td>
                                    <td>30 days</td>
                                </tr>
                                <tr>
                                    <td>wpconsent_preferences</td>
                                    <td>This cookie is used to store the user's cookie consent preferences.</td>
                                    <td>30 days</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>



                    {/* Login Cookies */}
                    <div className="cookie-block">
                        <h2>Login</h2>
                        <p>These cookies are used for managing login functionality on this website.</p>
                        <table className="cookie-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>wordpress_logged_in</td>
                                    <td>Used to store logged-in users.</td>
                                    <td>Persistent</td>
                                </tr>
                                <tr>
                                    <td>wordpress_sec</td>
                                    <td>Used to track the user across multiple sessions.</td>
                                    <td>15 days</td>
                                </tr>
                                <tr>
                                    <td>wordpress_test_cookie</td>
                                    <td>Used to determine if cookies are enabled.</td>
                                    <td>Session</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Google reCAPTCHA */}
                    <div className="cookie-block">
                        <h2>Google reCAPTCHA</h2>
                        <p>Google reCAPTCHA helps protect websites from spam and abuse by verifying user interactions through challenges.</p>
                        <table className="cookie-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>_GRECAPTCHA</td>
                                    <td>Set by Google reCAPTCHA when executed, for the purpose of providing risk analysis.</td>
                                    <td>179 days</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Statistics */}
                    <div className="cookie-block">
                        <h2>Statistics</h2>
                        <p>Statistics cookies collect information anonymously. This information helps us understand how visitors use our website.</p>
                        <h3>Google Analytics</h3>
                        <p>Google Analytics is a tool that tracks and analyzes website traffic to support informed marketing decisions. <a href="https://policies.google.com/privacy" target="_blank" rel="noreferrer" className="privacy-content__link">Learn more</a></p>
                        <table className="cookie-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Duration</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr><td>_gat</td><td>Monitors number of Google Analytics server requests when using Google Tag Manager.</td><td>1 minute</td></tr>
                                <tr><td>__utmc</td><td>Used with older Urchin versions of Google Analytics to distinguish between new sessions and visits at session end.</td><td>End of session</td></tr>
                                <tr><td>__utmz</td><td>Contains information about the traffic source or campaign that directed the user to the website.</td><td>6 months after last activity</td></tr>
                                <tr><td>__utmv</td><td>Contains custom information set via the _setCustomVar method in Google Analytics.</td><td>2 years after last activity</td></tr>
                                <tr><td>__utmx</td><td>Used to determine whether a user is included in an A/B or Multivariate test.</td><td>18 months</td></tr>
                                <tr><td>_ga</td><td>ID used to identify users.</td><td>2 years</td></tr>
                                <tr><td>_gali</td><td>Used by Google Analytics to determine which links on a page are being clicked.</td><td>30 seconds</td></tr>
                                <tr><td>_ga_</td><td>ID used to identify users.</td><td>2 years</td></tr>
                                <tr><td>_gid</td><td>ID used to identify users for 24 hours after last activity.</td><td>24 hours</td></tr>
                                <tr><td>_gac_</td><td>Contains information related to marketing campaigns, shared with Google Ads when accounts are linked.</td><td>90 days</td></tr>
                                <tr><td>__utma</td><td>ID used to identify users and sessions.</td><td>2 years after last activity</td></tr>
                                <tr><td>__utmt</td><td>Used to monitor number of Google Analytics server requests.</td><td>10 minutes</td></tr>
                                <tr><td>__utmb</td><td>Used to distinguish new sessions and visits. Updated every time data is sent to the Google Analytics server.</td><td>30 minutes after last activity</td></tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Section 4 */}
                    <h2>Third-Party Services</h2>
                    <p>We may use third-party service providers to support Website operations, such as:</p>
                    <ul>
                        <li>Website hosting and infrastructure providers</li>
                        <li>Security and fraud-prevention services</li>
                        <li>IT and system support vendors</li>
                    </ul>
                    <p>These service providers process information only on our behalf and only as necessary to perform their services for us. They are not authorized to use personal information for their own purposes.</p>

                    {/* Section 5 */}
                    <h2>Sharing of Information</h2>
                    <p>We do not sell personal information.</p>
                    <p>We may disclose information:</p>
                    <ul>
                        <li>To service providers acting on our behalf</li>
                        <li>To comply with applicable laws, regulations, legal processes, or governmental requests</li>
                        <li>To protect the rights, property, or safety of MIFAB, our users, or others</li>
                        <li>In connection with a corporate transaction, such as a merger, sale, or reorganization</li>
                    </ul>

                    {/* Section 6 */}
                    <h2>Data Retention</h2>
                    <p>We retain personal information only for as long as reasonably necessary to fulfill the purposes described in this Policy, comply with legal obligations, resolve disputes, and enforce our agreements.</p>

                    {/* Section 7 */}
                    <h2>Data Security</h2>
                    <p>We implement reasonable administrative, technical, and physical safeguards designed to protect personal information against unauthorized access, disclosure, alteration, or destruction.</p>
                    <p>No method of transmission or storage is completely secure, and we cannot guarantee absolute security.</p>

                    {/* Section 8 */}
                    <h2>California Privacy Rights</h2>
                    <p>If you are a California resident, you may have rights under the California Consumer Privacy Act ("CCPA") and the California Privacy Rights Act ("CPRA"), including the right to:</p>
                    <ul>
                        <li>Know what categories of personal information we collect and how it is used</li>
                        <li>Request access to or deletion of personal information</li>
                        <li>Request correction of inaccurate personal information</li>
                        <li>Opt out of the sale or sharing of personal information (if applicable)</li>
                        <li>Not be discriminated against for exercising your privacy rights</li>
                    </ul>
                    <p>To submit a request, please contact us using the information in Section 11 below. We may need to verify your identity before processing your request.</p>

                    {/* Section 9 */}
                    <h2>Children's Privacy</h2>
                    <p>The Website is intended for a general business audience and is not directed to children under the age of 13. We do not knowingly collect personal information from children.</p>

                    {/* Section 10 */}
                    <h2>Changes to This Privacy Policy</h2>
                    <p>We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated effective date. Your continued use of the Website after changes are posted constitutes acceptance of the revised Policy.</p>

                    {/* Section 11 */}
                    <h2>Contact Us</h2>
                    <p>If you have questions about this Privacy Policy or our privacy practices, please contact:</p>
                    <address>
                        MIFAB, Inc.<br />
                        1321 W 119th Street<br />
                        Chicago, IL 60643<br />
                        Phone: 800-465-2736
                    </address>

                </div>
            </div>
        </section>
    );
};

export default PrivacyPolicy;